module.exports = __webpack_public_path__ + "static/media/youtube-white.8450d7e8.svg";